// Скрипт для управления max-height при скролле на мобильных устройствах
(function() {
  'use strict';

  // Проверяем размер экрана
  function isMobile() {
    return window.innerWidth < 768;
  }

  // Добавляем CSS для плавной анимации max-height
  function addTransitionStyles() {
    if (!document.getElementById('scroll-height-control-styles')) {
      const style = document.createElement('style');
      style.id = 'scroll-height-control-styles';
      style.textContent = `
        .header__heading-logo-wrapper,
        [data-scroll-height-control] {
          transition: max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s ease-in-out !important;
          overflow: hidden !important;
          will-change: max-height;
        }
      `;
      document.head.appendChild(style);
    }
  }

  // Кэшируем элементы и переменные
  let targetElement = null;
  let lastScrollTop = 0;
  let initialScrollTop = 0;
  let scrollDistance = 0;
  let ticking = false;
  let scrollHandler = null;
  let resizeHandler = null;
  let isActive = false;
  const SCROLL_THRESHOLD = 50; // Минимальное расстояние прокрутки для срабатывания

  // Находим целевой элемент
  function findTargetElement() {
    if (!targetElement) {
      targetElement = document.querySelector('[data-scroll-height-control]') || 
                     document.querySelector('.header__heading-logo-wrapper');
    }
    return targetElement;
  }

  // Сохраняем оригинальную высоту элемента
  let originalHeight = null;

  // Сброс стилей - возвращаем полную высоту
  function resetStyles() {
    if (targetElement) {
      // Если оригинальная высота не сохранена, сохраняем её
      if (!originalHeight) {
        originalHeight = targetElement.scrollHeight;
      }
      
      // Устанавливаем overflow перед изменением
      targetElement.style.overflow = 'hidden';
      
      // Устанавливаем текущую высоту как начальное значение для анимации
      const currentHeight = targetElement.scrollHeight;
      targetElement.style.maxHeight = currentHeight + 'px';
      
      // Принудительный reflow
      void targetElement.offsetHeight;
      
      // В следующем кадре устанавливаем большое значение для анимации вверх
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (targetElement && originalHeight) {
            targetElement.style.maxHeight = (originalHeight + 50) + 'px';
            
            // После завершения анимации убираем ограничение
            setTimeout(() => {
              if (targetElement) {
                targetElement.style.maxHeight = '';
                targetElement.style.overflow = '';
              }
            }, 600);
          }
        });
      });
    }
  }

  // Применяем стили с плавной анимацией
  function applyStyles() {
    if (targetElement) {
      // Сохраняем оригинальную высоту при первом применении
      if (!originalHeight) {
        originalHeight = targetElement.scrollHeight;
      }
      
      // Получаем текущую высоту элемента
      const currentHeight = targetElement.scrollHeight || originalHeight;
      
      // Устанавливаем overflow перед изменением
      targetElement.style.overflow = 'hidden';
      
      // Устанавливаем текущую высоту как начальное значение max-height
      targetElement.style.maxHeight = currentHeight + 'px';
      
      // Принудительный reflow для запуска анимации
      void targetElement.offsetHeight;
      
      // В следующем кадре устанавливаем конечное значение для анимации
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (targetElement) {
            targetElement.style.maxHeight = '30px';
          }
        });
      });
    }
  }

  // Обработчик скролла
  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (!isMobile() || !targetElement) {
          ticking = false;
          return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDelta = scrollTop - lastScrollTop;
        
        // Если это первый скролл после инициализации, сохраняем начальную позицию
        if (initialScrollTop === 0) {
          initialScrollTop = scrollTop;
        }

        // Накапливаем расстояние прокрутки
        if (scrollDelta > 0) {
          // Скроллим вниз
          scrollDistance = Math.max(0, scrollDistance + scrollDelta);
        } else {
          // Скроллим вверх
          scrollDistance = Math.min(0, scrollDistance + scrollDelta);
        }

        // Проверяем, достигли ли порога в 50 пикселей
        if (Math.abs(scrollDistance) >= SCROLL_THRESHOLD) {
          if (scrollDistance > 0 && scrollTop > 100) {
            // Прокрутили вниз на 50px - устанавливаем height: 30px с плавной анимацией
            applyStyles();
          } else if (scrollDistance < 0) {
            // Прокрутили вверх на 50px - убираем height с плавной анимацией
            resetStyles();
            scrollDistance = 0; // Сбрасываем счетчик после применения
          }
        }
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        ticking = false;
      });
      ticking = true;
    }
  }

  // Обработчик изменения размера окна
  function handleResize() {
    if (!isMobile()) {
      resetStyles();
      scrollDistance = 0;
      initialScrollTop = 0;
      if (isActive) {
        removeEventListeners();
        isActive = false;
        targetElement = null;
      }
    } else {
      if (!isActive) {
        initScrollHeightControl();
      }
    }
  }

  // Добавляем обработчики событий
  function addEventListeners() {
    if (!scrollHandler) {
      scrollHandler = handleScroll;
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }
    if (!resizeHandler) {
      resizeHandler = handleResize;
      window.addEventListener('resize', resizeHandler, { passive: true });
    }
  }

  // Удаляем обработчики событий
  function removeEventListeners() {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }
  }

  // Инициализация скрипта
  function initScrollHeightControl() {
    if (!isMobile()) return;

    // Добавляем CSS стили для анимации
    addTransitionStyles();

    // Находим элемент
    if (!findTargetElement()) {
      // Если элемент не найден, пробуем еще раз через небольшую задержку
      setTimeout(function() {
        if (findTargetElement() && !isActive) {
          initScrollHeightControl();
        }
      }, 100);
      return;
    }

    if (!isActive) {
      addEventListeners();
      isActive = true;
    }
  }

  // Запускаем при загрузке DOM
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollHeightControl);
    } else {
      // Небольшая задержка для гарантии, что DOM полностью загружен
      setTimeout(initScrollHeightControl, 50);
    }
  }

  init();
})();

